module.exports = "/static/assets/ffca1ed0934b9b2ece7dd36f3a0f4fb0.png";